export default __webpack_public_path__ + "static/font-578f10c9bd4bd39f80b6724de25c5458.woff";